import React from 'react'

import * as Icon from './icons'

export interface Tool {
  text: string
  icon: React.ReactNode
  slug: string
  name: string
}

export const tools: Tool[] = [
  {
    text: 'Grammar Checker',
    icon: <Icon.Checkmark />,
    slug: 'grammar-check',
    name: 'Tool Suite Grammar Check',
  },
  {
    text: 'Plagiarism Checker',
    icon: <Icon.MagnifyingGlass />,
    slug: 'plagiarism-checker',
    name: 'Tool Suite Plagiarism Checker',
  },
  {
    text: 'Citation Generator',
    icon: <Icon.Citation />,
    slug: 'citations',
    name: 'Tool Suite Citation Generator',
  },
  {
    text: 'Paraphrasing Tool',
    icon: <Icon.Paraphrasing />,
    slug: 'paraphrasing-tool',
    name: 'Tool Suite Paraphrasing Tool',
  },
]
